import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    list: [],
    searchText: "",
    profileMainType: "organization",
    profileMainTypeOptions: [
        { label: "Organization", value: "organization" },
        { label: "Individual", value: "individual" },
    ],
    loading: false,
    selectedItemsId: [],
    clearSelection: false,
    addEditProfilePopup: {
        open: false,
        type: "organization",
        data: null,
    },
    deleteProfilePopup: {
        open: false,
        message: "",
        profileIds: [],
    },
};

const organizationSlice = createSlice({
    name: "custom-database-v2",
    initialState,
    reducers: {
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        setDatabaseType: (state, action) => {
            state.profileMainType = action.payload;
            state.selectedItemsId = [];
            state.clearSelection = !state.clearSelection;
        },
        setSelectedItemsId: (state, action) => {
            if (action.payload.length === 0)
                state.clearSelection = !state.clearSelection;
            state.selectedItemsId = action.payload;
        },
        setAddEditProfilePopup: (state, action) => {
            state.addEditProfilePopup = {
                ...state.addEditProfilePopup,
                ...action.payload,
            };
        },
        setDeleteProfilePopup: (state, action) => {
            state.deleteProfilePopup = {
                ...state.deleteProfilePopup,
                ...action.payload,
            };
        },
    },
});

export const {
    setSearchText,
    setFilterType,
    setDatabaseType,
    setSelectedItemsId,
    setAddEditProfilePopup,
    setDeleteProfilePopup,
} = organizationSlice.actions;
export default organizationSlice.reducer;
